import { render, staticRenderFns } from "./Gzjl.vue?vue&type=template&id=264d4676&"
import script from "./Gzjl.vue?vue&type=script&lang=js&"
export * from "./Gzjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports